/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import {
  Grid,
  Card,
  IconButton,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useApiRequest from "utils/Apirequest";
import { useMaterialUIController } from "context";
import { isValidEmail, isValidPhone } from "utils/Constant";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
};

function UpdateSupervisor() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();

  //   FULL SUPERVISOR OBJECT COMING FROM TABLE
  const supervisor = location.state;

  const apiRequest = useApiRequest();

  const [values, setValues] = useState(initialValues);
  const [showPassword, setShowPassword] = useState(false);

  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loadingLocations, setLoadingLocations] = useState(false);

  /* ================= AUTO-FILL FORM ================= */
  useEffect(() => {
    if (!supervisor?._id) {
      navigate(-1);
      return;
    }

    setValues({
      firstName: supervisor.firstName || "",
      lastName: supervisor.lastName || "",
      email: supervisor.email || "",
      phoneNumber: supervisor.phoneNumber || "",
      password: "",
    });

    setSelectedLocation(supervisor.locationId || null);
  }, [supervisor]);

  /* ================= Fetch Locations ================= */
  const fetchLocations = async () => {
    setLoadingLocations(true);
    const { data } = await apiRequest(
      "get",
      "charger-locations/location-id-name"
    );
    if (data?.success) {
      setLocations(data.data);
    }
    setLoadingLocations(false);
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  /* ================= Submit ================= */
  const handleSubmit = async () => {
    if (
      !values.firstName ||
      !values.lastName ||
      !values.email ||
      !values.phoneNumber ||
      !selectedLocation
    ) {
      return enqueueSnackbar("All fields are required", { variant: "error" });
    }

    if (!isValidEmail(values.email)) {
      return enqueueSnackbar("Invalid email", { variant: "error" });
    }

    if (!isValidPhone(values.phoneNumber)) {
      return enqueueSnackbar("Invalid phone number", { variant: "error" });
    }

    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phoneNumber: values.phoneNumber,
      locationId: selectedLocation._id,
      ...(values.password && { password: values.password }),
    };

    const { data } = await apiRequest(
      "put",
      `supervisor/update/${supervisor._id}`,
      payload
    );

    if (data?.success) {
      enqueueSnackbar("Supervisor updated successfully", {
        variant: "success",
      });
      navigate(-1);
    }
  };

  /* ================= UI ================= */
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
              >
                <MDTypography variant="h6" color="white">
                  Update Supervisor
                </MDTypography>
              </MDBox>

              <MDBox p={3}>
                <MDInput
                  label="First Name"
                  value={values.firstName}
                  fullWidth
                  margin="dense"
                  onChange={(e) =>
                    setValues({ ...values, firstName: e.target.value })
                  }
                />

                <MDInput
                  label="Last Name"
                  value={values.lastName}
                  fullWidth
                  margin="dense"
                  onChange={(e) =>
                    setValues({ ...values, lastName: e.target.value })
                  }
                />

                <MDInput
                  label="Email"
                  value={values.email}
                  fullWidth
                  margin="dense"
                  onChange={(e) =>
                    setValues({ ...values, email: e.target.value })
                  }
                />

                <MDInput
                  label="Phone Number"
                  value={values.phoneNumber}
                  fullWidth
                  margin="dense"
                  onChange={(e) =>
                    setValues({ ...values, phoneNumber: e.target.value })
                  }
                />

          

                <Autocomplete
                  options={locations}
                  value={selectedLocation}
                  getOptionLabel={(o) => o?.locationName || ""}
                  isOptionEqualToValue={(o, v) => o._id === v._id}
                  onChange={(e, v) => setSelectedLocation(v)}
                  loading={loadingLocations}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      margin="dense"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingLocations && (
                              <CircularProgress size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />

                <Grid container justifyContent="flex-end" mt={3}>
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={handleSubmit}
                  >
                    Update
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default UpdateSupervisor;
